import { lazyLoad } from "$routes/_lib/lazy-load";
import { RequireAuth } from "$routes/_lib/require-auth";
import { Role } from "elephant-web/gql";
import { Route, Routes } from "react-router-dom";

const ControlPanelPage = lazyLoad(() =>
  import(/* webpackChunkName: "Admin" */ "./chunk").then((module) => ({
    default: module.default.ControlPanelPage,
  })),
);

const BillingManagementPage = lazyLoad(() =>
  import(/* webpackChunkName: "Admin" */ "./chunk").then((module) => ({
    default: module.default.BillingManagementPage,
  })),
);

const InvestigationItemGeneratorPage = lazyLoad(() =>
  import(/* webpackChunkName: "Admin" */ "./chunk").then((module) => ({
    default: module.default.InvestigationItemGeneratorPage,
  })),
);

const DataExportPage = lazyLoad(() =>
  import(/* webpackChunkName: "Admin" */ "./chunk").then((module) => ({
    default: module.default.DataExportPage,
  })),
);

const { Admin, DataExporter, Elephant } = Role;

export const AdminRoutes = () => (
  <Routes>
    <Route
      path="control-panel"
      element={
        <RequireAuth>
          <ControlPanelPage />
        </RequireAuth>
      }
    />
    <Route
      path="billing-management"
      element={
        <RequireAuth only={[Admin, Elephant]}>
          <BillingManagementPage />
        </RequireAuth>
      }
    />
    <Route path="investigations">
      <Route
        path="item-generator"
        element={
          <RequireAuth only={[Elephant]}>
            <InvestigationItemGeneratorPage />
          </RequireAuth>
        }
      />
    </Route>
    <Route
      path="data-export"
      element={
        <RequireAuth only={[DataExporter, Elephant]}>
          <DataExportPage />
        </RequireAuth>
      }
    />
  </Routes>
);
